import type { ChangeWorkGroup, InternalSubtaskTemplate } from '../../types/changes';

/**
 * Garante que modelos vinculados no cadastro apareçam em flattenInternalSlots
 * mesmo se a API de work-groups não os listou (link N:N / contagem desatualizada).
 */
export function augmentWorkGroupsWithCatalogTemplates(
  groups: ChangeWorkGroup[],
  catalog: InternalSubtaskTemplate[],
): ChangeWorkGroup[] {
  if (!catalog.length) return groups;
  const byGroupId = new Map<number, ChangeWorkGroup>();
  for (const group of groups) {
    byGroupId.set(group.group_id, {
      ...group,
      internal_templates: [...(group.internal_templates || [])],
    });
  }
  for (const tpl of catalog) {
    if (tpl.is_active === false) continue;
    const linked = tpl.linked_group_ids || tpl.linked_groups?.map((g) => g.group_id) || [];
    for (const groupId of linked) {
      const gid = Number(groupId);
      if (!gid) continue;
      const group = byGroupId.get(gid);
      if (!group) continue;
      const list = group.internal_templates || [];
      if (list.some((item) => item.id === tpl.id)) continue;
      list.push({
        id: tpl.id,
        name: tpl.name,
        default_title: tpl.default_title,
        field_count: tpl.field_count ?? 0,
        show_on_dispatch: tpl.show_on_dispatch !== false,
        owner_user_id: tpl.owner_user_id,
        is_personal: tpl.is_personal ?? (tpl.owner_user_id != null),
      });
      group.internal_templates = list;
    }
  }
  return Array.from(byGroupId.values());
}
